// src/hooks/useAllPresets.js
import { useEffect, useState } from "react";
import { listSchemas } from "../api/schemas";
import { dbItemToPreset } from "../utils/normalizeSchema";

// merge by id so user/global DB items override hardcoded duplicates
function mergeById(basePresets, extraPresets) {
  const map = new Map(basePresets.map(p => [p.id, p]));
  for (const p of extraPresets) map.set(p.id, p); // later wins
  return Array.from(map.values());
}

export function useAllPresets(localPresets) {
  const [presets, setPresets] = useState(localPresets);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const rows = await listSchemas();        // returns global + user schemas (your new Lambda)
        const fromDb = rows.map(dbItemToPreset); // normalize to your shape
        const merged = mergeById(localPresets, fromDb);
        if (!cancelled) {
          setPresets(merged);
          setError("");
        }
      } catch (e) {
        if (!cancelled) setError(e.message || "Failed to load schemas");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [localPresets]);

  return { presets, loading, error };
}
